import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import SettingsPage from './pages/SettingsPage';
import SiteManagement from './pages/SiteManagement';
import TrackingCodeManager from './components/TrackingCodeManager';
import LandingPage from './pages/LandingPage';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import { useAuth } from './hooks/useAuth';
import Register from './pages/Register';
import AuthPage from './components/Auth/AuthPage';
import FormManagement from './pages/FormManagement';
import CreateForm from './pages/CreateForm';
import EditForm from './pages/EditForm';
import FormSubmissions from './pages/FormSubmissions';

function App() {
  // Always call hooks at the top level
  const auth = useAuth();
  const isAuthenticated = auth?.isAuthenticated || false;
  const isLoading = auth?.isLoading || false;

  // While checking authentication status, show loading state
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-pulse flex flex-col items-center">
          <div className="h-12 w-12 bg-indigo-200 rounded-full mb-4"></div>
          <div className="h-4 w-32 bg-gray-200 rounded mb-2"></div>
          <div className="h-3 w-24 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<LandingPage />} />
      <Route 
        path="/login" 
        element={isAuthenticated ? <Navigate to="/dashboard" /> : <AuthPage />} 
      />
      <Route path="/register" element={<AuthPage />} />
      
      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/sites" element={<SiteManagement />} />
        <Route path="/tracking" element={<TrackingCodeManager />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/forms" element={<FormManagement />} />
        <Route path="/forms/new" element={<CreateForm />} />
        <Route path="/forms/:formId/edit" element={<EditForm />} />
        <Route path="/forms/:formId/submissions" element={<FormSubmissions />} />
      </Route>
      
      {/* 404 page */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}


export default App;